// extracted by mini-css-extract-plugin
export default {"mainContainer":"ArticleDownload_mainContainer__4QEDN","containerImgDownload":"ArticleDownload_containerImgDownload__qCOWS","imgDownload":"ArticleDownload_imgDownload__6y7-l"};